import { accessRole } from "../../../../helpers/access_role";
import apiResponse from "../../../../services/apiResponse";
import React, { Component, Fragment, createRef, useState, useRef } from "react";
import DatePicker from "../../../../helpers/ui/DatePicker";

import {
  Label,
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Badge,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { cancelToken } from "../../../../services/adapters/base";
import Select from "../../../../helpers/ui/CustomSelect";
import CustomSelectGroup from "../../../../helpers/ui/CustomSelectGroup";

import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";

import TableActiveComponent from "./Components/TableActiveComponent";
import PeriodListComponent from "./Components/PeriodListComponent";

import IndexBloc from "./Blocs/IndexBloc";

var reformatOptionEselonFungsional = function (option) {
  var grouped = groupBy(option, (pet) => pet.echelon_fungsional_categori);
  var listopsigroup = Array.from(grouped);

  return listopsigroup.map(function (opsi) {
    var newObj = {};

    newObj["label"] = opsi[0];
    newObj["options"] = opsi[1].map(function (options) {
      var newOpsi = {};
      newOpsi["value"] = options.echelon_uuid;
      newOpsi["label"] = options.echelon_name_full;

      return newOpsi;
    });

    return newObj;
  });
};
function groupBy(list, keyGetter) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

class IndexView extends Component {
  indexBloc = new IndexBloc();
  source;
  timer;

  constructor(props) {
    super(props);
    this.state = {
      activeTab: "1",
      modal: false,
      list: [],
      eselon: [],
      eselon_struktural: [],
      eselon_fungsional: [],
      workUnit: [],
      rankOption: [],
      rankSelected: null,
      draft: 0,
      currentPeriod: null,
      showPeriodList: false,
      is_struktural: 0,
      filter: {
        filter_value: "",
        page_number: 1,
        page_size: 20,
        sort_order: {
          column: "work_unit_sort",
          order: "asc",
        },
      },
      typeKemenkeuOptions : [
        { value: "Struktural", label: "Struktural" },
        { value: "Fungsional", label: "Fungsional" },
        { value: "Pelaksana", label: "Pelaksana" },
      ]
    };
    this.activeRef = createRef();
  }

  reloadActiveRef = () => this.activeRef.current.setTokenAPI();

  toggleModal = () => this.setState({ modal: !this.state.modal });

  loadDraft = async () => {
    await this.indexBloc.fetchDraft({}, this.source.token);
  };

  loadEselon = async (val) => {
    await this.indexBloc.fetchEselon(
      {
        echelon_is_pns: val,
      },
      this.source.token
    );
  };

  loadRank = async (val) => {
    await this.indexBloc.fetchRank(
      {
        rank_is_pns: val,
      },
      this.source.token
    );
  };

  loadWorkUnit = async () => {
    await this.indexBloc.fetchWorkUnit({}, this.source.token);
  };

  setTokenAPI = () => {
    if (typeof this.source != typeof undefined) {
      this.source.cancel();
    }
    this.source = cancelToken();
    this.loadDraft();
    this.loadWorkUnit();
    // this.loadEselon();
  };

  handlePeriodList = (response) => {
    this.setState(
      {
        loadingCurrent: true,
      },
      () => {
        this.setState({
          showPeriodList: false,
          currentPeriod: response,
          loadingCurrent: false,
        });
      }
    );
  };

  onChangeCategorySelected = (type) => {
    if (type.value == 0) {
      var Options = [
        { value: "2", label: "Fungsional Umum" },
        { value: "3", label: "Fungsional Tertentu" },
      ];
    } else {
      var Options = [
        { value: "1", label: "Struktural" },
        { value: "2", label: "Fungsional Umum" },
        { value: "3", label: "Fungsional Tertentu" },
      ];
    }

    this.setState({
      Options: Options,
    });

    this.loadEselon(type.value);
    this.loadRank(type.value);
  };

  onChangeRankSelected = (type) => {
    debugger;
    console.log(type);
    this.setState({
      rankSelected: type.label,
    });
  };

  reformatOptionsPns = function (datas) {
    return datas.map(function (data) {
      debugger;
      var newObj = {};
      newObj["label"] = `${data.rank_name} (${data.rank_group_room})`;
      newObj["value"] = data.rank_uuid;
      return newObj;
    });
  };

  reformatOptionsPppk = function (datas) {
    return datas.map(function (data) {
      var newObj = {};
      newObj["label"] = data.rank_name;
      newObj["value"] = data.rank_uuid;
      return newObj;
    });
  };

  // reformatOptionsPppk = (raw, value, label1, label2) => {
  //   return raw.map(function (data) {
  //     var newObj = {};
  //     newObj["label"] = data[label1] + " " + data[label2];
  //     newObj["value"] = data[value];
  //     return newObj;
  //   });
  // };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  submitData = async () => {
    await this.indexBloc.fetchCreate(this.state.dataForm);
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
          modal: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
          modal: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
          modal: false,
        };
        break;
      case "failed":
        forState = {
          failed: false,
          modal: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount = () => {
    this.setTokenAPI();

    this.indexBloc.eselonChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            eselon: result.data.response.eselon_struktural,
            eselon_struktural: result.data.response.eselon_struktural,
            eselon_fungsional: reformatOptionEselonFungsional(
              result.data.response.eselon_fungsional
            ),
          });

          break;
        case apiResponse.ERROR:
          this.setState({});
          break;
        default:
          break;
      }
    });

    this.indexBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          debugger;
          if (response.rank_is_pns == 0) {
            this.setState({
              rankOption: this.reformatOptionsPppk(response.result),
            });
          } else {
            this.setState({
              rankOption: this.reformatOptionsPns(response.result),
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({});
          break;
        default:
          break;
      }
    });

    this.indexBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        // case apiResponse.COMPLETED:
        //   this.setState({
        //     loading: false,
        //     success: true,
        //   });
        //   this.loadDraft();
        //   break;
        // case apiResponse.ERROR:
        //   this.setState({
        //     loading: false,
        //     failed: true,
        //   });
        //   break;
        // default:
        //   break;
        case apiResponse.COMPLETED:
          // console.log();
          if (result.data.status === true) {
            console.log("buat");
            this.setState({
              loading: false,
              success: true,
            });
          } else {
            console.log("ada");
            this.setState({
              failedInfo: result.data.message,
              loading: false,
              failed: true,
            });
          }

          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
            failedInfo: result.data.message,
          });
          break;
        default:
          break;
      }
    });

    this.indexBloc.draftChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            draft: result.data.response?.total,
          });
          break;
        case apiResponse.ERROR:
          this.setState({});
          break;
        default:
          break;
      }
    });

    this.indexBloc.workUnitChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.LOADING:
          break;
        case apiResponse.COMPLETED:
          const response = result.data.response;
          this.setState({
            workUnit: result.data.response.result,
          });
          break;
        case apiResponse.ERROR:
          this.setState({});
          break;
        default:
          break;
      }
    });
  };

  componentWillUnmount() {
    this.indexBloc.workUnitChannel?.unsubscribe();
    this.indexBloc.eselonChannel?.unsubscribe();
    this.indexBloc.draftChannel?.unsubscribe();
    this.indexBloc.createChannel?.unsubscribe();
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Card>
            <CardBody>
              <div className="float-end">
                {accessRole("create") && (
                  <div className="waves-effect" style={{ marginRight: 5 }}>
                    <Button color="primary" onClick={() => this.toggleModal()}>
                      Tambah Jabatan Baru
                    </Button>
                  </div>
                )}
              </div>
              <CardTitle>Jabatan</CardTitle>
              <CardSubtitle>List Jabatan</CardSubtitle>
              <hr />
              <Row>
                <Col md={12}>
                  <div className="d-flex flex-row bd-highlight">
                    <div
                      className="pe-2 pb-2 bd-highlight"
                      style={{ paddingTop: 7 }}
                    >
                      <span>
                        <Button
                          color="success"
                          style={{ marginRight: 5 }}
                          onClick={() =>
                            this.setState({ showPeriodList: true })
                          }
                        >
                          <i className="uil-align-left"></i> Lihat Histori
                        </Button>
                        {accessRole("approve") && (
                          <Link
                            to="/master/position.html?draft"
                            style={{ marginRight: 5 }}
                          >
                            <Button color="secondary">
                              <i className="uil-align-left"></i> Draft{" "}
                              <Badge color="primary">
                                {this.state.draft ? this.state.draft : 0}
                              </Badge>
                            </Button>
                          </Link>
                        )}
                      </span>
                    </div>
                  </div>
                </Col>
              </Row>
              <hr />
              <TableActiveComponent
                ref={this.activeRef}
                handleInactiveSuccess={() => this.reloadActiveRef()}
                loadDraft={() => this.loadDraft()}
                currentPeriod={this.state.currentPeriod}
              />
            </CardBody>
          </Card>
        </Container>

        <Modal
          size="lg"
          isOpen={this.state.modal}
          toggle={() => this.toggleModal()}
        >
          <ModalHeader toggle={() => this.toggleModal()}>
            Tambah Jabatan Baru
          </ModalHeader>
          <AvForm
            className="needs-validation"
            onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
          >
            <ModalBody>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Kategori Pegawai <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <Select
                    onChange={this.onChangeCategorySelected}
                    name="position_is_pns"
                    errorMessage="Pilih Kategori Pegawai"
                    options={[
                      { value: "0", label: "PPPK" },
                      { value: "1", label: "PNS" },
                    ]}
                    placeholder="Pilih Kategori Pegawai"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Nama Jabatan <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <AvField
                    name="position_name"
                    placeholder="Nama Jabatan"
                    errorMessage="Masukkan Nama Jabatan"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Nama Jabatan Kemenkeu<span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <AvField
                    name="position_name_kemenkeu"
                    placeholder="Nama Jabatan Kemenkeu"
                    errorMessage="Masukkan Nama Jabatan Kemenkeu"
                    type="text"
                    className="form-control"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">Unit Kerja</Label>
                <Col md="8">
                  <Select
                    name="position_work_unit_uuid"
                    errorMessage="Pilih Unit Kerja"
                    options={this.state.workUnit}
                    optionLabel="work_unit_name"
                    optionValue="work_unit_uuid"
                    placeholder="Pilih Unit Kerja"
                  />
                </Col>
              </Row>

              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Jenis Jabatan <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <Select
                    name="position_type"
                    errorMessage="Pilih Jenis Jabatan"
                    options={this.state.Options}
                    onChange={(v) =>
                      this.setState({
                        is_struktural: v.value,
                      })
                    }
                    placeholder="Pilih Jenis Jabatan"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Jenis Jabatan Kemenkeu <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <Select
                    name="position_type_kemenkeu"
                    errorMessage="Pilih Jenis Jabatan Kemenkeu"
                    options={this.state.typeKemenkeuOptions}
                    // onChange={(v) =>
                    //   this.setState({
                    //     is_struktural: v.value,
                    //   })
                    // }
                    placeholder="Pilih Jenis Jabatan Kemenkeu"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              {this.state.is_struktural == 1 ? (
                <Row className="mb-3">
                  <Label className="col-md-4 col-form-label">
                    Eselon/Jenjang
                  </Label>
                  <Col md="8">
                    <Select
                      name="position_echelon_uuid"
                      errorMessage="Pilih Eselon/Jenjang"
                      options={this.state.eselon_struktural}
                      optionLabel="echelon_name_full"
                      optionValue="echelon_uuid"
                      placeholder="Pilih Eselon/Jenjang"
                      // validate={{ required: { value: true } }}
                    />
                  </Col>
                </Row>
              ) : (
                ""
              )}
              {this.state.is_struktural == 3 ? (
                <Row className="mb-3">
                  <Label className="col-md-4 col-form-label">
                    Eselon/Jenjang
                  </Label>
                  <Col md="8">
                    <Select
                      name="position_echelon_uuid"
                      errorMessage="Pilih Eselon/Jenjang"
                      options={this.state.eselon_fungsional}
                      placeholder="Pilih Eselon/Jenjang"
                      // validate={{ required: { value: true } }}
                    />
                  </Col>
                </Row>
              ) : (
                ""
              )}

              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Batas Usia Pensiun <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <AvField
                    name="position_bup"
                    placeholder="Batas Usia Pensiun"
                    errorMessage="Masukkan Batas Usia Pensiun"
                    type="number"
                    className="form-control"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  {" "}
                  Grade / Golongan
                  <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <Select
                    onChange={this.onChangeRankSelected}
                    name="position_rank_uuid"
                    errorMessage="Pilih  Grade / Golongan"
                    options={this.state.rankOption}
                    optionLabel="label"
                    optionValue="value"
                    placeholder="Pilih  Grade / Golongan"
                    validate={{ required: { value: true } }}
                  />
                  <Col md="8">
                    <AvField
                      // readOnly
                      type="hidden"
                      name="position_grade_name"
                      placeholder="grade"
                      className="form-control"
                      value={this.state.rankSelected}
                    />
                  </Col>
                </Col>
              </Row> */}

              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Grade <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <AvField
                    name="position_grade"
                    placeholder="Grade"
                    type="number"
                    className="form-control"
                    errorMessage=" Grade "
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>

              {/* <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Grade / Golongan Romawi
                </Label>
                
              </Row> */}
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Tanggal Berlaku <span className="text-danger">*</span>
                </Label>
                <Col md="8">
                  <DatePicker
                    isDisabled={this.state.detailUuid != null ? true : false}
                    name="position_start_date"
                    isWeekday={false}
                    dateFormat="dd/MM/yyyy"
                    errorMessage="Masukan Tanggal Berlaku"
                    validate={{ required: { value: true } }}
                  />
                </Col>
              </Row>
              <Row className="mb-3">
                <Label className="col-md-4 col-form-label">
                  Tanggal Berakhir
                </Label>
                <Col md="8">
                  <DatePicker
                    name="position_end_date"
                    isWeekday={false}
                    dateFormat="dd/MM/yyyy"
                    errorMessage="Masukan Tanggal Berakhir"
                    validate={{ required: { value: false } }}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" type="submit">
                Submit
              </Button>{" "}
              <Button onClick={() => this.toggleModal()}>Cancel</Button>
            </ModalFooter>
          </AvForm>
        </Modal>

        <Modal
          size="lg"
          isOpen={this.state.showPeriodList}
          toggle={() =>
            this.setState({ showPeriodList: !this.state.showPeriodList })
          }
        >
          <ModalHeader>Daftar Periode Jabatan</ModalHeader>
          <ModalBody>
            <PeriodListComponent changeUUID={this.handlePeriodList} />
          </ModalBody>
        </Modal>

        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin data tersebut sudah benar?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo={this.state.failedInfo} //"Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
      </Fragment>
    );
  }
}

export default IndexView;
